import { handleColorType } from '@quizzach/styles';
import { useTheme } from 'styled-components';

interface ArrowDownProps {
	height?: number;
	color?: string;
}
export const ArrowDown = ({ height, color }: ArrowDownProps) => {
	let width = 148;
	const heightAdjusted = height || 31;
	if (height) {
		width = (148 / 31) * height;
	}
	const theme = useTheme();

	return (
		<svg
			width={width}
			height={heightAdjusted}
			viewBox='0 0 148 31'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M146 2L79.4367 27.8857C75.9398 29.2456 72.0602 29.2456 68.5633 27.8857L2 2'
				stroke={color ? handleColorType(color, theme) : '#00FFC2'}
				strokeWidth='4'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};
